module.exports = __webpack_public_path__ + "static/img/case_logo_08.1783aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_logo_08.png
// module id = gqnL
// module chunks = 34